import { render, staticRenderFns } from "./productitemunits.vue?vue&type=template&id=6df3a7d4&scoped=true"
import script from "./productitemunits.vue?vue&type=script&lang=js"
export * from "./productitemunits.vue?vue&type=script&lang=js"
import style0 from "./productitemunits.vue?vue&type=style&index=0&id=6df3a7d4&prod&scoped=true&lang=css"
import style1 from "./productitemunits.vue?vue&type=style&index=1&id=6df3a7d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df3a7d4",
  null
  
)

export default component.exports